<template>
	<!-- 左侧内容 -->
	<div class="mineBoxL bw bs">

		<!-- 头部 -->
		<div class="mineBoxLT df dfc aic ptb20">
			<!-- 头像 -->
			<div class="userPhoto">
				<el-avatar :src="userphoto"></el-avatar>
			</div>
			<!-- 用户名 -->
			<div class="userName mt10">{{nickName}}</div>
			<!-- 等级 -->
			<div class="userLevel pr mt5">
<!--				<img src="../assets/tag-vip.png" >-->
				<div class="tc-tag">{{level}}</div>
			</div>
			<!-- 退出登录 -->
			<div class="backLogin mt5 caaa f12 cp" @click="backLogin">退出登录</div>
		</div>

		<!-- 列表 -->
		<div class="mineBoxLB">
			<ul>
				<router-link :to="item.to" v-for="(item,index) in mineleft" :key="index">
					<li :class="(item.to == url)? 'active' : '' ">
						<div>{{item.name}}</div>
						<div class="more"><img src="../assets/minListMore.png" ></div>
					</li>
				</router-link>
			</ul>
		</div>

	</div>
</template>
<script>
	// 全局变量
	var that;

	export default{
		// 页面变量
		data() {
			return {
				// 用户头像
				userphoto: require("../assets/userphoto.png"),
				// 左侧列表
				mineleft: [
					{
						name: '账户信息',
						to: '/mineinfo',
					},
					{
						name: '修改密码',
						to: '/minerepwd',
					},
					{
						name: 'KEY',
						to: '/minekey',
					},
				],
				// 路径
				url: '',

				// 用户名称
				nickName: '未登录',
				// 用户等级
				level: '',
				// 注册时间
				registerDate: '0000-00-00',
			}
		},

		// 实例化后
		created() {
			that = this;

			// 赋值
			that.url = that.$route.path;

			// 获取用户信息
			that.getuserInfo();

		},

		// 方法集
		methods:{

			// 获取用户信息
			getuserInfo(){
				// 用户名称
				that.nickName = localStorage.getItem('memberName');
				// 用户等级
				// that.level = localStorage.getItem('memberLevelId');
				that.level = localStorage.getItem('memberLevelName');
        console.log("=======")
        console.log(localStorage)
        console.log(localStorage.getItem('memberLevelId'))
			},

			// 退出登录
			backLogin(){
        // 跳转登录
        this.changeLocalStorage()
        that.$route.path == "/index" ? location.reload() : that.$router.replace("/index");
        that.$message.info('退出成功');
			},
      changeLocalStorage(){
          // 缓存token
          localStorage.removeItem('token');
          // 用户id
          localStorage.removeItem('memberId');
          // 用户名称
          localStorage.removeItem('memberName');
          // 缓存用户身份
          localStorage.removeItem('memberLevelId');
          // 等级
          localStorage.removeItem('memberLevelName');
          // 注册时间
          localStorage.removeItem('createTime');
        }
		},
	};
</script>
<style>
/* 左侧盒子 */
.mineBoxL {
	width: 170px;
}
/* 用户头像 */
.userPhoto {
	width: 36px;
	height: 36px;
}
/* 用户等级 */
.userLevel {
	width: 46px;
	height: 18px;
}
/* 用户等级文字 */
.userLevelTxt {
	right: 3px;
	line-height: 18px;
}
/* 左盒子列表 */
.mineBoxLB ul li {
	display: flex;
	justify-content: space-between;
	padding: 15px 20px;
	text-indent: 20px;
	color: #333;
	font-size: 14px;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li .more {
	opacity: 0;
	transition: .2s;
}
/* 左侧盒子鼠标经过 */
.mineBoxLB ul li:hover {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左侧盒子鼠标经过更多箭头 */
.mineBoxLB ul li:hover .more {
	opacity: 1;
}
/* 左侧盒子选中样式 */
.mineBoxLB ul li.active {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li.active .more {
	opacity: 1;
}
.tc-tag {
  /*background: #fff1e9;*/
  color: #be5a00
}
</style>
